module.exports = __webpack_public_path__ + "static/img/curved14.34ecccd6.jpg";